enum HtmlHeading {
    H5 = 5,
    H4 = 4,
    H3 = 3,
    H2 = 2,
    H1 = 1
}

export default HtmlHeading;